// extracted by mini-css-extract-plugin
module.exports = {"root":"CropperModal_root__186q-","cropper":"CropperModal_cropper__3xEX7","footer":"CropperModal_footer__ZOO3W"};